<app-user-offer-details-component offerBundleType="offer" [offerId]="offerId()" />
